<!-- 标签拉群 -->
<template>
  <div>
    <el-page-header class="page-header" @back="goBack" content="标签拉群">
    </el-page-header>
    <div class="container Mmain">
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="12rem">
        <div class="form-header">
          <el-form-item label="任务名称：" prop="name">
            <el-input
              clearable
              style="width: 47rem"
              placeholder="请输入名称"
              v-model="form.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="客户标签：" prop="group_label">
            <div class="person">
              <el-tag
                v-for="item of arrth"
                style="margin: 0 1.2rem 0 0"
                
                effect="plain"
                :key="item"
              >
                {{ item }}
              </el-tag>
            </div>
            <el-button class="addBtn" icon="el-icon-plus" @click="onTagDialog()"
              >前往添加</el-button
            >
          </el-form-item>
          <el-form-item label="入群内容：" prop="content">
            <el-input
              clearable
              style="width: 47rem"
              placeholder="请输入内容"
              v-model="form.content"
            ></el-input>
          </el-form-item>
          <el-form-item label="选择群活码：" prop="url">
            <div class="chatCode">
              <el-image
                v-if="form.url"
                style="width: 1rem; height: 1rem;margin-left:-0.6rem"
                :src="form.url"
                :preview-src-list="[form.url]"
                fit="scale-down"
              ></el-image>
              <el-button type="text" style="text-align: left;"  @click="onSelectChat"
                >选择群活码</el-button
              >
            </div>
          </el-form-item>
        </div>
        <div class="form-footer">
          <el-form-item label-width="2.5rem">
            <el-button type="primary" :disabled="isLock" @click="onSubmit()">立即创建</el-button>
            <!-- <el-button style="margin-left: 2rem" @click="$router.back()"
              >取消</el-button
            > -->
          </el-form-item>
        </div>
      </el-form>
    </div>
    <el-dialog title="选择群活码" center :visible.sync="chatShow">
      <div>
        <div>
          <nav class="navbar">
            <div class="nav-l">
              <el-input
                clearable
                style="width: 28rem; margin-left: 2.4rem"
                placeholder="请输入活码名称"
                prefix-icon="el-icon-search"
                v-model="q"
                @change="getList()"
              >
                <el-button slot="append" @click="getList()">查询</el-button>
              </el-input>
            </div>
            <div class="nav-r">
              <el-date-picker
                v-model="time"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="getList()"
              >
              </el-date-picker>
            </div>
          </nav>

          <div class="container">
            <el-table
              :data="list"
              style="margin-top: 2rem"
              border
              highlight-current-row
              
              @row-click="rowClick"
            >
              <el-table-column label width="35">
                <template slot-scope="scope">
                  <el-radio :label="scope.row.id" v-model="radioId"
                    >&nbsp;</el-radio
                  >
                </template>
              </el-table-column>
              <el-table-column prop="name" label="群活码名称">
              </el-table-column>
              <el-table-column prop="code_image" label="群活码图片">
                <template slot-scope="scope">
                  <el-image
                    style="width: 7rem; height: 7rem"
                    :src="scope.row.code_image"
                    :preview-src-list="[scope.row.code_image]"
                    fit="scale-down"
                  ></el-image>
                </template>
              </el-table-column>
              <el-table-column prop="gruop_count" label="上传群数量">
              </el-table-column>
              <el-table-column prop="author" label="创建人"></el-table-column>
              <el-table-column prop="createtime" label="创建时间">
              </el-table-column>
            </el-table>
            <div class="paging">
              <pagination
                :total="total"
                :page.sync="listQuery.page"
                :limit.sync="listQuery.limit"
                :page-sizes="[10,20,50,100]"
                @pagination="getData"
              />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="chatShow = false">取 消</el-button>
        <el-button type="primary" @click="chatShow = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="请选择标签" center :visible.sync="dialogTableVisible">
      <div v-for="item of tags" :key="item.group_id" class="tag-item">
        <el-checkbox
          v-model="item.checkAll"
          @change="handleCheckAllChange(item)"
          >{{ item.group_name }}</el-checkbox
        >
        <div style="margin: 1.5rem 0"></div>
        <el-checkbox-group
          v-model="item.checkedCities"
          @change="handleCheckedCitiesChange(item)"
        >
          <el-checkbox
            v-for="city in item.child"
            :label="city"
            :key="city.tag_id"
            >{{ city.tag_name }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="offDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "setGroupsDetail",
  data() {
    return {
      form: {
        name: "",
        group_label: "",
        content: "",
        media_id: "",
        url: "",
      },
      rules: {
        name: [{ required: true, message: "请输入任务名称", trigger: "blur" }],
        group_label: [
          { required: true, message: "请选择客户标签", trigger: "blur" },
        ],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        url: [{ required: true, message: "请选择群活码", trigger: "blur" }],
      },
      checkList: [],
      module: "",
      chatShow: false,
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      q: "",
      time: "",
      star_time: "",
      end_time: "",
      multipleSelection: [],
      radioId: 0,
      dialogTableVisible: false,
      tags: [],
      arrth: [],
      isLock: false,
    };
  },

  computed: {},

  mounted() {
    if (this.$route.query.id) {
      this.getData();
    }
    this.getList();
  },
  methods: {
    handleCheckAllChange(val) {
      const findItem = this.tags.find((item) => {
        return item.group_id === val.group_id;
      });
      findItem.checkedCities = val.checkAll ? findItem.child : [];
      findItem.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      const findItem = this.tags.find((item) => {
        return item.group_id === value.group_id;
      });
      let checkedCount = value.checkedCities.length;
      findItem.checkAll = checkedCount === findItem.child.length;
      findItem.isIndeterminate =
        checkedCount > 0 && checkedCount < findItem.child.length;
    },
    getLabelListUseAdmin() {
      this.axios
        .post(
          "/crm/Assistant/getLabelListUseAdmin",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          let data = res.data.data;

          data.map((item) => {
            item.checkAll = false;
            item.checkedCities = [];
            item.isIndeterminate = true;
          });
          if (this.form.group_label) {
            // 回显选中数据
            this.from.group_label = JSON.parse(this.form.group_label);

            for (const d of data) {
              for (const g of this.form.group_label) {
                // 因为需要回显数据， 需要在全部数据内寻找与之对应的提交数据， 传递给全部数据中已选中字段checkedCities(已选中字段)
                if (d.group_id === g.group_id) {
                  // 由于全部数据checkedCities（已选中字段）只有与全部数据内的child相同才能回显选中效果，而提交后的child不行
                  // 因为提交的child对象虽然与全部数据对象内容一样，但两个对象是不相等的，它们并不是一个引用
                  // 对提交数据child与全部数据child比较，当相等时把全部数据的child相同条目传入checkedCities(已选中字段)
                  for (const c of g.child) {
                    for (const k of d.child) {
                      if (c.tag_id === k.tag_id) {
                        d.checkedCities.push(k);
                      }
                    }
                  }
                  let checkedCount = d.checkedCities.length;
                  d.checkAll = checkedCount === d.child.length;
                  d.isIndeterminate =
                    checkedCount > 0 && checkedCount < d.child.length;
                }
              }
            }
          }
          this.tags = data;
        })
        .catch(function (err) {});
    },
    offDialog() {
      const arr = [];
      for (var a = 0; a < this.tags.length; a++) {
        for (var k = 0; k < this.tags[a].checkedCities.length; k++) {
          arr.push(this.tags[a].checkedCities[k].tag_name);
        }
      }
      this.form.group_label = arr.toString();
      this.arrth = arr;
      this.dialogTableVisible = false;
    },
    onTagDialog() {
      this.dialogTableVisible = true;
      this.getLabelListUseAdmin();
    },
    rowClick(row) {
      this.radioId = row.id;
      this.form.url = row.code_image;
      this.form.media_id = row.media_id;
    },
    async getList() {
      if (Array.isArray(this.time)) {
        this.star_time = new Date(this.time[0]).getTime();
        this.end_time = new Date(this.time[1]).getTime();
        this.star_time = this.star_time / 1000;
        this.end_time = this.end_time / 1000;
      } else {
        this.star_time = "";
        this.end_time = "";
      }
      const { data: res } = await this.axios({
        url: "/crm/GroupLiveCodeTwo/LiveCodesList",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          name: this.q,
          star_time: this.star_time,
          end_time: this.end_time,
        }),
      });
      if (res.code == 1) {
        this.list = res.data.data;
        this.total = res.data.total;
      }
    },
    onSelectChat() {
      this.chatShow = true;
    },
    async getData() {
      const { data: res } = await this.axios({
        url: "/crm/AssistantLabel/getMassListone",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id: this.$route.query.id,
          page: this.listQuery.page,
          number_page: this.listQuery.limit,
        }),
      });
      if (res.code == 1) {
        const d = res.data;
        this.form.name = d.name;
        this.form.user = d.user;
        this.form.content = d.content;
        this.form.url = d.url;
        this.form.media_id = d.media_id;
        this.checkList = d.user_name_array.map((item, index) => {
          return {
            name: item,
            userid: d.user_array[index],
          };
        });
      } else if (res.code == 0) {
        this.$message.error(res.msg);
      }
    },
    goBack() {
      this.$router.back();
    },
    handleSelect(person) {
      switch (this.module) {
        case "getUserLists":
          this.checkList = person;
          const users = this.checkList.map((i) => {
            return i.userid;
          });
          this.form.user = String(users);
          break;
        default:
          break;
      }
    },
    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.isLock=true;
          this.submitForm();
          setTimeout(() => {
				  this.isLock = false
			}, 1000)
        
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async submitForm() {
      let url = "/crm/AssistantLabel/addMass";
      const params = {
        usertoken: this.tooken.usertoken,
        account_id: this.tooken.account_id,
        phone: this.tooken.phone,
        name: this.form.name,
        group_label: this.form.group_label,
        content: this.form.content,
        media_id: this.form.media_id,
        url: this.form.url,
      };
      const { data: res } = await this.axios({
        url,
        method: "POST",
        data: this.qs.stringify(params),
      });
      if (res.code == 1) {
        this.goBack();
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>
<style  scoped>
.chatCode {
  display: flex;
  flex-direction: column;
}
.tag-item {
  margin-top: 3.2rem;
  border-bottom: .1rem dashed #dddddd;
  padding-bottom: 2rem;
}
.tag-item:nth-child(1) {
  margin-top: 0;
}

.form-footer {
  margin-top: 4rem;
  padding-top: 4rem;
  border-top: .1rem solid #ebeef5;
}
.Mmain{
  background-color: #ffffff;
  border-radius: .8rem;
  padding: 4rem 2rem;
}
.el-form-item{
margin-bottom: 4rem;
}
</style>